import { render, staticRenderFns } from "./profile-menu.vue?vue&type=template&id=af870e0e"
import script from "./profile-menu.vue?vue&type=script&lang=js"
export * from "./profile-menu.vue?vue&type=script&lang=js"
import style0 from "./profile-menu.vue?vue&type=style&index=0&id=af870e0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports